<template>
    <v-card
        v-if="!loading"
        flat
    >
        <v-card-text
            :class="isMobile ? 'pa-0' : ''"
        >
            <v-layout
                wrap
                :class="isMobile ? 'pa-0' : ''"
            >
                <v-flex
                    xs12
                    :class="isMobile ? 'pa-0' : ''"
                >
                    <custom-table
                        ref="customTable"

                        data-url="/quotations/versions"
                        :single-item-name="'version'"
                        :plural-item-name="'versions'"
                        :headers="headers"
                        :additional-data="{id: $route.params.quotationId}"
                        :breakpoint="950"

                        :filter-button="false"

                        clickable
                        @click="view"

                        flat
                    >
                        <template
                            slot="row"
                            slot-scope="props"
                        >
                            <td>
                                {{ props.item.name }}
                            </td>
                            <td>
                                <template
                                    v-if="checkNested(props.item, 'client', 'name')"
                                >
                                    {{ props.item.client.name }}
                                </template>
                            </td>
                            <td
                                class="text-center"
                            >
                                {{ props.item.reference_number }} <br>
                            </td>
                            <td
                                class="text-center"
                            >
                                <v-tooltip
                                    bottom
                                    v-if="checkNested(props.item, 'total_premium') && checkNested(props.item, 'monthly_payment')"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <span
                                            v-on="on"
                                        >
                                            {{ props.item.total_premium | currency }}
                                        </span>
                                    </template>
                                    <span>
                                        Total Monthly Payment: {{ props.item.monthly_payment | currency }}
                                    </span>
                                </v-tooltip>
                            </td>
                            <td
                                class="text-center"
                            >
                                {{ props.item.version }}
                            </td>
                            <td
                                class="text-center"
                            >
                                <template
                                    v-if="checkNested(props.item, 'selected_lpp_label')"
                                >
                                    {{ props.item.selected_lpp_label }}
                                </template>
                            </td>
                            <td
                                class="text-center"
                            >
                                Created at: {{ props.item.created_at|date }} <br> {{ props.item.created_at|fromNow }}
                            </td>
                        </template>

                        <template
                            slot="card"
                            slot-scope="props"
                        >
                            <td
                                class="v-data-table__mobile-row"
                                v-for="(header, headerIndex) in headers"
                                :key="headerIndex"
                            >
                                <div class="v-data-table__mobile-row__header">
                                    {{ header.text }}
                                </div>
                                <div class="v-data-table__mobile-row__cell">
                                    <template
                                        v-if="header.value === 'client_name'"
                                    >
                                        <template
                                            v-if="checkNested(props.item, 'client', 'name')"
                                        >
                                            {{ props.item.client.name }}
                                        </template>
                                    </template>
                                    <template
                                        v-else-if="header.value === 'premium'"
                                    >
                                        <template
                                            v-if="checkNested(props.item, 'total_premium')"
                                        >
                                            {{ props.item.total_premium | currency }} <br>
                                        </template>
                                    </template>
                                    <template
                                        v-else
                                    >
                                        {{ $refs.customTable.getCardValue(props.item, header.value) }}
                                    </template>
                                </div>
                            </td>
                        </template>
                    </custom-table>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>
<script>
    export default {
        data() {
            return {
                loading: true,
                quotation: {},

                headers: [
                    {text: 'Name', value: 'name', align: 'left', sortable: false},
                    {text: 'Client name', value: 'client_name', align: 'left', sortable: false},
                    {text: 'Reference', value: 'reference_number', align: 'center', sortable: false},
                    {text: 'Premium', value: 'premium', align: 'center', sortable: false},
                    {text: 'Version', value: 'version', align: 'center', sortable: false},
                    {text: 'Selected LPP™ ', value: 'selected_lpp_label', align: 'center', sortable: false},
                    {text: 'Created', value: 'created_at', align: 'center', sortable: false},
                ],

                updating: false,
            }
        },
        props: ['itemInfo'],
        name: 'Quotation-Versions',
        mounted() {
            this.quotation = this.itemInfo;

            setTimeout(() => {
                this.loading = false;
            }, 100);
        },

        methods: {
            view(item) {
                this.$router.push('/quotations/view/' + item.id + '?tab=info');
            },
            getChipColor(item) {
                if (item.type === 1) {
                    return 'purple';
                }

                if (item.type === 2) {
                    return 'accent';
                }

                return 'pink darken-4';
            },
            getChipContent(item) {
                if (item.type === 1) {
                    return 'MyCover™';
                }

                if (item.type === 2) {
                    return 'HomeVantage™';
                }

                return 'KeyPlan™';
            }
        }
    }
</script>
